import { render, staticRenderFns } from "./ChangeSupplier.vue?vue&type=template&id=c703fc8e&lang=pug"
import script from "./ChangeSupplier.vue?vue&type=script&lang=js"
export * from "./ChangeSupplier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports